import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash-es';
import { Controller, useWatch, useFormContext } from 'react-hook-form';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { buildYearMakesPath, VehicleModel } from 'client/data/models/vehicle-v2';
import { PUB_STATES } from 'client/constants/pub-states';
import { TrackingHandler } from 'client/tracking/handler';
import { Select } from 'site-modules/lease-deals/components/deals-checker-widget/ui/select/select';
import { DEAL_CHECKER_CREATIVE_ID } from 'site-modules/lease-deals/components/deals-checker-widget/constants';
import { TrackingConstant } from 'client/tracking/constant';

const LEASE_PUB_STATES = [PUB_STATES.NEW, PUB_STATES.NEW_USED];

function MakeSelectorUI({ makes = undefined, year = undefined }) {
  const { control, resetField, setValue } = useFormContext();
  const options = (makes || []).map(m => ({ value: m.niceName, label: m.name }));

  const handleMakeChange = useCallback(
    (value, label) => {
      setValue('make', value, { shouldValidate: true });
      setValue('makeName', label, { shouldValidate: true });
      resetField('model');
      resetField('modelName');
      TrackingHandler.fireEvent('deal_checker_make_select', {
        event_data: {
          value: label,
          creative_id: DEAL_CHECKER_CREATIVE_ID,
          action_cause: TrackingConstant.SELECT_CHANGE,
        },
      });
    },
    [resetField, setValue]
  );

  return (
    <Controller
      name="make"
      control={control}
      rules={{ required: true }}

      render={({ field: { ref, ...restField } }) => (
        <Select
          {...restField}
          options={options}
          labelText="Make"
          toggle="Select make"
          disabled={!year}
          isLoading={!!year && isUndefined(makes)}
          onChange={handleMakeChange}
        />
      )}
    />
  );
}

MakeSelectorUI.propTypes = {
  year: PropTypes.string,
  makes: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, niceName: PropTypes.string })),
};

const MakeSelectorConnected = connectToModel(MakeSelectorUI, {
  makes: bindToPath(({ year }) => year && buildYearMakesPath(year, LEASE_PUB_STATES), VehicleModel),
});

export function MakeSelector() {
  const year = useWatch({ name: 'year' });
  return <MakeSelectorConnected year={year} />;
}
